import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface TimerContextValue {
  now: number;
}

const TimerContext = createContext<TimerContextValue | undefined>(undefined);

export function TimerProvider({ children }: { children: ReactNode }) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    // Update immediately
    setNow(Date.now());

    // Then update every second
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <TimerContext.Provider value={{ now }}>
      {children}
    </TimerContext.Provider>
  );
}

export function useTimerContext() {
  const context = useContext(TimerContext);
  if (!context) {
    throw new Error('useTimerContext must be used within TimerProvider');
  }
  return context;
}
